import React from 'react'
import PageMeta from '../../components/common/PageMeta'
import DefaultTable from '../../components/tables/DefaultTable/DefaultTable'
import Badge from '../../components/ui/badge/Badge'
import { useNavigate } from 'react-router'
import Card from '../../components/common/Card'
import ProductCreate from './Create/ProductCreate'
import { useCreate } from '../../context/CreateRegisterContext'

export default function Product() {
    const navigate = useNavigate()
    const { openProduct, setOpenProduct } = useCreate()

    const rows = [
        {
            id: 1,
            name: 'Pneu de trator',
            customName: (
                <div className='flex items-center'>
                    <img
                        className='w-10 h-10 rounded-full mr-3'
                        src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSTyE-Em6QufD36BJJVfRn-5wePBXT31mTlhA&s'
                        alt='user photo'
                    />
                    <div className=''>
                        <p className='font-bold'>Pneu de trator</p>
                        <p className='text-xs'>Cantu</p>
                    </div>
                </div>
            ),
            code: '45ews54sd',
            situation: <Badge color='success'>Ativo</Badge>
        },
        {
            id: 2,
            name: 'Pneu de caminhão',
            customName: (
                <div className='flex items-center'>
                    <img
                        className='w-10 h-10 rounded-full mr-3'
                        src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSTyE-Em6QufD36BJJVfRn-5wePBXT31mTlhA&s'
                        alt='user photo'
                    />
                    <div className=''>
                        <p className='font-bold'>Pneu de caminhão</p>
                        <p className='text-xs'>Cantu</p>
                    </div>
                </div>
            ),
            code: '43340dsfs',
            situation: <Badge color='success'>Ativo</Badge>
        },
        {
            id: 3,
            name: 'Pneu de picape',
            customName: (
                <div className='flex items-center'>
                    <img
                        className='w-10 h-10 rounded-full mr-3'
                        src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSTyE-Em6QufD36BJJVfRn-5wePBXT31mTlhA&s'
                        alt='user photo'
                    />
                    <div className=''>
                        <p className='font-bold'>Pneu de picape</p>
                        <p className='text-xs'>Cantu</p>
                    </div>
                </div>
            ),
            code: '44d4ddd0',
            situation: <Badge color='error'>Inativo</Badge>
        }
    ]

    const columns = [
        {
            key: 'customName',
            label: 'Nome do produto'
        },
        {
            key: 'code',
            label: 'Código do produto'
        },
        {
            key: 'situation',
            label: 'Situação'
        }
    ]

    const handleClick = (row: any) => {
        navigate(`/produto/${row.id}`)
    }

    return (
        <>
            <PageMeta title='Produtos | CRM' description='Lista todos os produtos' />
            <div className='space-y-6'>
                <Card>
                    <DefaultTable
                        columns={columns}
                        rows={rows}
                        rowsPerPage={20}
                        handleClick={handleClick}
                        handleCreate={() => setOpenProduct(true)}
                    />
                </Card>
            </div>
            <ProductCreate open={openProduct} handleClose={() => setOpenProduct(false)} />
        </>
    )
}
